import styled from 'styled-components';

const RestSelectStyles = styled.div`
  width: 100%;
`;

export default RestSelectStyles;
